import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from '../../nest-api';
import {
  AddData,
  RequestAddDto,
  RequestAddNewShiftPatternDto,
  RequestCheckBeforeDeletePatternDto,
  RequestEditDto,
  RequestEditShiftPatternNameDto,
  ResponseGetShiftDailiesListingDto,
  ResponseGetShiftPatternsListingDto,
} from '../dto/shift-daily.dto';
import { ResponseData } from '../../nest-responses';
import { responseArray } from '../../nest-model/nest-model';

@Injectable()
export class ShiftDailyApi {

  private readonly service: string = '';
  private readonly model: string = 'shiftDaily';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getShiftDailiesListing(): Observable<ResponseGetShiftDailiesListingDto> {

    const method: string = 'POST';
    const func: string = 'getShiftDailiesListing';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetShiftDailiesListingDto>(method, url, params, urlParams, body);
  }

  public getShiftDailiesListingNew(payload: {remark: string}, queryParams: {page: number, limit: number}) {

    const method: string = 'POST';
    const func: string = 'getShiftDailiesListingNew';
    const params: any = payload;
    const urlParams: any = queryParams;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public getOvertimeCode() {
    const method: string = 'POST';
    const func: string = 'getOvertimeCode';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public add(payload: RequestAddDto): Observable<ResponseData<AddData>> {
    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<AddData>>(method, url, params, urlParams, body);
  }

  public edit(payload: RequestEditDto): Observable<ResponseData<string>> {
    const method: string = 'POST';
    const func: string = 'edit';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  public getShiftPatternsListing(): Observable<ResponseData<ResponseGetShiftPatternsListingDto[]>> {
    const method: string = 'POST';
    const func: string = 'getShiftPatternsListing';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetShiftPatternsListingDto[]>>(method, url, params, urlParams, body);
  }

  public getShiftPatternsListingNew(payload: {shiftgroupname?: string;}, queryParams: {page: number, limit: number}) {
    const method: string = 'POST';
    const func: string = 'getShiftPatternsListingNew';
    const params: any = payload;
    const urlParams: any = queryParams;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public editShiftPatternName(payload: RequestEditShiftPatternNameDto): Observable<ResponseData<string>> {
    const method: string = 'POST';
    const func: string = 'editShiftPatternName';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  public checkBeforeDeletePattern(payload: RequestCheckBeforeDeletePatternDto): Observable<ResponseData<string>> {
    const method: string = 'POST';
    const func: string = 'checkBeforeDeletePattern';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  public addNewShiftPattern(payload: RequestAddNewShiftPatternDto): Observable<ResponseData<string>> {
    const method: string = 'POST';
    const func: string = 'addNewShiftPattern';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  public getShiftPatterns(): Observable<ResponseData<any>> {
    const method: string = 'GET';
    const func: string = 'getShiftPatterns';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public editShiftPattern(payload: any): Observable<ResponseData<string>> {
    const method: string = 'POST';
    const func: string = 'editShiftPattern';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  /**
   *
   * START
   * MOVED FROM src/shared/nestjs/attendance/shift-daily-api.ts
   */
  public getEmployeesShiftPattern(payload): Observable<responseArray<any>> {
    const method: string = 'POST';
    const func: string = 'getEmployeesShiftPattern';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<responseArray<any>>(method, url, params, urlParams, body);
  }

  public getShiftPatternProdHours(payload): Observable<responseArray<any>> {
    const method: string = 'POST';
    const func: string = 'getShiftPatternProdHours';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<responseArray<any>>(method, url, params, urlParams, body);
  }

  /**
   *
   * END
   * MOVED FROM src/shared/nestjs/attendance/shift-daily-api.ts
   */

  public saveShiftPattern(payload): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'saveShiftPattern';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public checkShiftOverlap(payload): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'checkShiftOverlap';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/shift-daily.api.ts